// Module
var code = " <gh-notification-queue [items]=\"items\"></gh-notification-queue>";
// Exports
module.exports = code;